import { ServiceProvider } from "../dependencies_management/ServiceProvider";
import { AnalyticsFunc } from "../types/AnalyticsFunc";
import { WindowLocationWrapper } from "../utilities/window_wrapping/WindowLocationWrapper";
import { AnalyticsTracker } from "./AnalyticsTracker";

export class BingAnalyticsTracker extends AnalyticsTracker<undefined> {
	private readonly windowLocation: WindowLocationWrapper;

	constructor(
		private readonly sendBingEvent: AnalyticsFunc,
		serviceProvider: ServiceProvider
	) {
		super();
		this.windowLocation = serviceProvider.getWindowLocationWrapper();
	}

	submitPageView(): void {
		this.sendBingEvent("event", "page_view", {
			page_path: this.windowLocation.pathWithQueryString,
		});
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	submitEvent(_eventData: undefined): void {
		// intentionally left empty as there are no events that we need to submit to Bing
	}
}
